import { Widget } from './form-widget.model';
import { LASER_NOTE_MAX_LENGTH } from './form-widget-emr-laser.constants';

export class FbEmrLaserWidget extends Widget {
  constructor(data?: unknown) {
    super(data);

    this.name = 'fb-emr-laser';
    this.title = 'Laser';

    this.properties.text ??= { title: 'Header', value: 'Laser' };
  }

  public isValid(): boolean {
    if (this.properties?.items?.hidden) {
      return true;
    }

    if (this.properties?.items?.formInvalid) {
      return false;
    }

    const items = this.properties?.items?.value;

    if (!Array.isArray(items)) {
      return true;
    }

    return items.every((item) => this.isNoteValid(this.getNote(item)));
  }

  private getNote(item: unknown): unknown {
    if (!item || typeof item !== 'object') {
      return null;
    }

    return (item as { notes?: unknown }).notes;
  }

  private isNoteValid(value: unknown): boolean {
    if (value === null || value === undefined) {
      return true;
    }

    return String(value).length <= LASER_NOTE_MAX_LENGTH;
  }
}
